<script>
  import { onMount } from 'svelte';

  let squareCount = 0;

  onMount(() => {
    const squaresInterval = setInterval(() => {
      squareCount = (squareCount + 1) % 4;
    }, 500);

    return () => {
      clearInterval(squaresInterval);
    };
  });
</script>

<style>
  .square {
    width: 6px;
    height: 6px;
    background-color: rgba(255, 255, 255, 0.5);
    margin-right: 4px;
  }
</style>

<div 
  class="absolute right-2 top-1/2 transform -translate-y-1/2 text-2xl font-bold text-white h-6 w-6 flex items-center justify-center"
>
  {#each Array(squareCount).fill() as _, i}
    <div class="square"></div>
  {/each}
</div>


